<div #overlay class="confirm-overlay" [ngStyle]="style">
    <div class="confirm-content center-content">
        <div class="center-content column-flex">
            <h2 data-cy="cancel-dialog-label">{{ mainLabel }}</h2>
            <h2 class="subLabel" *ngIf="subLabel">{{ subLabel }}</h2>
            <div class="window-button-container window-button-margin">
                <button data-cy="cancel-dialog-cancel-button" class="window-button component-large button-stay-color" (click)="emitValue(false)">
                    {{ cancelLabel }}
                </button>
                <button data-cy="cancel-dialog-confirm-button" class="window-button component-large button-leave-color" (click)="emitValue(true)">
                    {{ confirmLabel }}
                </button>
            </div>
        </div>
    </div>
</div>